var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:{ 'spinner-center': _vm.center }},[_c('div',{staticClass:"spinner-border",class:_vm.classList,attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }